module.exports = __webpack_public_path__ + "static/media/airbnb.e5de5c92.png";